import React from 'react'
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import './index.scss'

export default function UserHeaderView() {
    const navigate = useNavigate()
        , { logo, serverUrl } = useSelector(state => state.siteInfo)

    return (
        <div className='user-header-container'>
            <div className='content'>
                <div className='content-left'>
                    <img
                        onClick={() => navigate('/')}
                        src={serverUrl + logo} alt="" />
                </div>
            </div>
        </div>
    )
}
